import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const CircleIcon = styled.div`
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background-color: #444b62;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
`;

const ImageIcon = styled.img`
  width: 22px;
`;

const MenuSlide = styled.div`
  position: fixed;
  width: 340px;
  height: 174px;
  bottom: 120px;
  right: 10px;
  background-color: #0dc152;
  color: #fff;
  border-radius: 8px;
  text-align: center;
  font-size: 30px;
  box-shadow: -1px 1px 8px 3px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: -1px 4px 16px 10px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: -1px 1px 8px 3px rgba(0, 0, 0, 0.2);
  z-index: 2000;
  transition: all 0.3s ease-in-out;
  @media (min-width: 601px) {
    width: 360px;
    right: 30px;
  }
  &:after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 280px;
    background: transparent;
    width: 0px;
    height: 0px;
    border-bottom: 15px solid white;
    border-right: 12px solid transparent;
    border-left: 12px solid transparent;
    transform: rotate(180deg);
    @media (min-width: 601px) {
      left: 318px;
    }
  }
`;

const MenuSlideHeader = styled.div`
  background: #00b952;
  color: #ffffff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height: 73px;
  padding: 16px 15px 16px 20px;
  display: flex;
  justify-content: space-between;
`;

const TextTitle = styled.div`
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  display: flex;
`;

const TextDescription = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  display: flex;
`;

const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const ContainerClose = styled.div`
  display: flex;
  align-items: flex-start;
`;

const Close = styled.img`
  width: 16px;
  cursor: pointer;
`;

const ContainerBottom = styled.div`
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  padding: 20px 16px 20px 16px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  height: 101px;
  align-items: center;
`;

const ContainerImageAndText = styled.div`
  display: flex;
  align-items: center;
`;

const PhoneNumber = styled.div`
  padding-top: 6px;
  color: #a2a7ba;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  justify-content: flex-start;
`;

const PhoneLegend = styled.div`
  color: #444b62;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  justify-content: flex-start;
  padding-bottom: 6px;
`;

const ContainerPhoneAndLegend = styled.div`
  display: flex;
  flex-direction: column;
`;

const WpGreen = styled.img`
  width: 24px;
`;

const ContainerClick = styled.div`
  display: flex;
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  justify-content: space-between;
  padding: 8px;
  cursor: pointer;
  &:hover {
    background: rgba(0, 185, 82, 0.2);
  }
`;

const ContainerWpIcon = styled.div`
  display: flex;
  align-items: center;
`;

const MenuSlider = ({ handleClick, closeMenu }) => {
  const { t } = useTranslation();

  return (
    <>
      <MenuSlide>
        <MenuSlideHeader>
          <ContainerText>
            <TextTitle>{t('floatingWhatsApp.title')}</TextTitle>
            <TextDescription>{t('floatingWhatsApp.subTitle')}</TextDescription>
          </ContainerText>
          <ContainerClose>
            <Close id="whatsapp-close" src="close.svg" onClick={closeMenu} />
          </ContainerClose>
        </MenuSlideHeader>
        <ContainerBottom>
          <ContainerClick id="whatsapp-redirect" onClick={handleClick}>
            <ContainerImageAndText>
              <CircleIcon>
                <ImageIcon src="shop.svg" />
              </CircleIcon>
              <ContainerPhoneAndLegend>
                <PhoneNumber>{t('floatingWhatsApp.phone')}</PhoneNumber>
                <PhoneLegend>{t('floatingWhatsApp.description')}</PhoneLegend>
              </ContainerPhoneAndLegend>
            </ContainerImageAndText>
            <ContainerWpIcon>
              <WpGreen src="wpGreen.svg" />
            </ContainerWpIcon>
          </ContainerClick>
        </ContainerBottom>
      </MenuSlide>
    </>
  );
};

export default MenuSlider;
